import React from 'react'
import Style from './RequestInfo.module.css'
import moment from 'moment-jalaali'
const RequestInfo = ({info}) => {
  return (
    <fieldset className={Style.fieldSetHolder}>
    <legend>اطلاعت کلی درخواست</legend>
    <div>
        <strong >نام درخواست دهنده:</strong>
        <span>{info?.requested_user}</span>
    </div>
    <div>
        <strong >شماره درخواست دهنده:</strong>
        <span>{info?.requested_user_phone}</span>
    </div>
   {info?.request_date&& <div>
        <strong >  تاریخ درخواست:</strong>
        <span>{moment.unix(parseInt(info?.request_date)).format("jYYYY/jM/jD----hh:mm:ss a")}</span>
    </div>}
    {info?.accept_date&&<div>
        <strong >  تاریخ قبول درخواست:</strong>
        <span>{moment.unix(parseInt(info?.accept_date)).format("jYYYY/jM/jD----hh:mm:ss a")}</span>
    </div>}
    {info?.arrive_date&&<div>
        <strong >  تاریخ تحویل محصول:</strong>
        <span>{moment.unix(parseInt(info?.arrive_date)).format("jYYYY/jM/jD----hh:mm:ss a")}</span>
    </div>}
    <div>
        <strong > دسته بندی محصول:</strong>
        <span>{info?.category}</span>
    </div>
    <div>
        <strong >حدود طول مسیر:</strong>
        <span>{info?.distance} متر</span>
    </div>
    <div>
        <strong >توضیحات محصول:</strong>
        <span>{info?.product_description}</span>
    </div>
    <div>
        <strong >وسیله نقلیه درخواستی:</strong>
        <span>{info?.requested_vehicle_type}</span>
    </div>
    
  </fieldset>
  )
}

export default RequestInfo